/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from "react";
import { LikeAndDislikeProps } from "../Services/CommonServices/propTypes";
import FeedbackModal from "./FeedbackModal";
import { useSelector, useDispatch } from "react-redux";
import { likeordislike } from "../Services/ApiServices/chatServices";
import { likeApiError } from "../Services/Redux/Reducers/feedBackSlice";
import { isWarning } from "../Services/Redux/Reducers/commonSlice";
import { cloneDeep } from "lodash";

function LikeAndDislike(props) {
  const conList = useSelector((state) => state.chat.conversationList);
  const responseId = props.responseId;
  const [isThumsUp, setIsThumsUp] = useState(false);
  const [isThumsDown, setIsThumsDown] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isWarningClose, setIsWarningClose] = useState(true);
  const [isiOS, setiOS] = useState(false);
  const dispatch = useDispatch();
  const islikeApiError = useSelector((state) => state.feedBack.likeApiError);
  const stateShowLike = useSelector((state) => state.feedBack.showLikeDisLikeState);

  const onThumsUpHandle = (status) => {
    setIsThumsUp(!isThumsUp);
    setIsThumsDown(false);
    if (!isThumsUp) {
      updateResponseStatus(status);
    } else {
      updateResponseStatus("");
    }
  };

  const onThumsDownHandle = (status) => {
    setIsThumsDown(!isThumsDown);
    setIsThumsUp(false);
    setIsOpenModal(true);
    if (!isThumsDown) {
      updateResponseStatus(status);
    } else {
      updateResponseStatus("");
    }
  };

  const handleClose = useCallback(() => {
    setIsOpenModal(false);
  });

  // onclick like/unlike
  const updateResponseStatus = (status) => {
    let convo = cloneDeep(conList);
    let lastItem = convo.pop();
    let responseStatus = {
      responseId: lastItem.uid,
      status: status,
    };
    likeordislike(
      responseStatus,
      (response) => {
        dispatch(likeApiError(true));
      },
      (err) => {
        setIsThumsUp(false);
        setIsThumsDown(false);
        dispatch(likeApiError("Please try again."));
      }
    );
  };

  useEffect(() => {
    let userAgent = window.navigator.userAgent.toLowerCase(),
      macosPlatforms = /(macintosh|macintel|macppc|mac68k|macos)/i,
      iosPlatforms = /iPad|iPhone|iPod/i,
      safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if ((macosPlatforms.test(userAgent)) || safari || iosPlatforms.test(userAgent)) {
      setiOS(true);
    }
  }, []);

  return (
    <div className="feedback-spacing">
      {stateShowLike && (
        <>
          <div className={`likeAndWarningWrapper wrapper d-flex ${!isWarningClose && 'wrapper-margin'}`} style={{ position: "relative" }}>
            {props.badIntentResponseCode !== "Other" && <div>
            {conList?.length > 1 && (
              <div className=" likeDislikeModule" style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "start",
                alignItems: "center",
                gap: "12px",
                marginLeft: "8px",
              }}>
                {conList?.length > 1 && (
                  <div className="" style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "12px",
                  }}>
                    <div className="">
                      <div>
                        <div className="" style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "start",
                          alignItems: "center",
                          gap: "12px",
                          height: "100%",
                        }}>
                          <button name="thumbsUp" className="feedback p-0">
                            <img
                              className="point"
                              src={
                                !isThumsUp
                                  ? "./static/assets/DesktopThumbsUp.svg"
                                  : "./static/assets/likeSolid.svg"
                              }
                              alt="img"
                              onClick={() =>
                                onThumsUpHandle(!isThumsUp ? "like" : "")
                              }
                            />
                          </button>
                          <button name="thumbsDown" className="feedback p-0">
                            <img
                              className="point"
                              src={
                                !isThumsDown
                                  ? "./static/assets/DesktopThumbsDown.svg"
                                  : "./static/assets/dislikeSolid.svg"
                              }
                              alt="img"
                              onClick={(e) =>
                                onThumsDownHandle(!isThumsDown ? "dislike" : "")
                              }
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    {conList?.length === 2 && !(isThumsUp || isThumsDown) && (
                      <div className="">
                        <span className={`wrapper_spanMsg ${isiOS && 'help_text_ios'}`}>
                          Help us improve our responses
                        </span>
                      </div>
                    )}
                  </div>
                )}
                {(isThumsUp || isThumsDown) && islikeApiError === true ? (
                  <div className="">
                    <span className={` wrapper_spanMsg fb_text ${isiOS && 'fb_text_ios'}`} style={{ textAlign: "center" }}>
                      Thank you for your feedback.
                    </span>
                  </div>
                ) : (
                  <div className="generic-error-txt ms-2">{islikeApiError}</div>
                )}
              </div>
            )}
            </div>}

            {
              conList.length < 2 && (<div className="warningModule" style={{ height: "56px"}}></div>)
            }

            {isWarningClose && props.sessionChange && (
              <div className="wrapper_greetingTextBox"
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  width: "100%",
                  zIndex: "1"
                }}>
                <span className="wrapper_greetingTextBox_inputBox">
                  AI generated advice may be incorrect. Please check responses
                  for accuracy.
                </span>
                <button
                  name="closeButton"
                  className="cross_btn"
                  style={{ padding: "10px 16px" }}
                >
                  {" "}
                  <img
                    src="/static/assets/close.svg"
                    height="10px"
                    width="10px"
                    alt="arrow-img"
                    onClick={() => { setIsWarningClose(false); dispatch(isWarning(true)); }}
                  />
                </button>
              </div>
            )}
          </div>

          {isThumsDown && (
            <FeedbackModal
              responseId={responseId}
              showModel={isOpenModal}
              handleClose={handleClose}
            />
          )}
        </>
      )}
    </div>
  );
}

LikeAndDislike.propTypes = LikeAndDislikeProps;

export default LikeAndDislike;
